export default __webpack_public_path__ + "static/media/maintenance-mode.f6bc64d3.png";